import { ArrowRightSolid } from './ArrowRightSolid';
import { AppBadge } from './AppBadge';
import { CircleCheckSolid } from './CircleCheckSolid';
import { CircleExclamationSolid } from './CircleExclamationSolid';
import { CopySolid } from './CopySolid';
import { InformationSharpSolid } from './InformationSharpSolid';
import { SMSBadge } from './SMSBadge';
import { StarIcon } from './StarIcon';
import { ToggleDirectionCircle } from './ToggleDirectionCircle';
import { TrashSolid } from './TrashSolid';
import { XmarkRegular } from './XmarkRegular';
import { UploadCloudIcon } from './UploadCloudIcon';
export {
  ArrowRightSolid,
  AppBadge,
  CircleCheckSolid,
  CircleExclamationSolid,
  CopySolid,
  InformationSharpSolid,
  SMSBadge,
  StarIcon,
  ToggleDirectionCircle,
  TrashSolid,
  XmarkRegular,
  UploadCloudIcon,
};
